import { parseQuery } from '@helpers/initFit'
import { getStorageValue, setStoredValue } from '@helpers/hooks/useStorage'
import { CustomAttribute } from 'types/checkout'

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term'
] as const

export const UTM_STORAGE_KEY = 'utm_params'

export function extractUtmParams(search: string): Record<string, string> {
  const parsed = parseQuery(search)
  return UTM_KEYS.reduce<Record<string, string>>((acc, key) => {
    if (parsed[key]) {
      acc[key] = parsed[key]
    }
    return acc
  }, {})
}

export function storeUtmParams(params: Record<string, string>): void {
  setStoredValue('localStorage', UTM_STORAGE_KEY, params)
}

export function getStoredUtmParams(): Record<string, string> {
  return getStorageValue('localStorage', UTM_STORAGE_KEY, {})
}

export function utmParamsToCartAttributes(
  params: Record<string, string>
): CustomAttribute[] {
  return Object.entries(params).map(([key, value]) => ({
    key: `_${key}`,
    value
  }))
}
